class CrossGame {
  middleNumber;
  horizontalNumbers = new Array(5);
  verticalNumbers = new Array(5);
  allNumbers = [];
  solutions = 0;
  totalCounts = 0;
  uniqueSolutionsList = [];
  // allSolutions = [];

  constructor() {
    this.allNumbers = [];
    this.horizontalNumbers = new Array(5);
    this.verticalNumbers = new Array(5);
    this.solutions = 0;
    this.totalCounts = 0;
    this.uniqueSolutionsList = [];
    // this.allSolutions = [];
  }

  setMiddleNumber(middleNumber) {
    if (middleNumber) {
      // If middle number is provided, use the provided middle number
      this.middleNumber = middleNumber;
    } else {
      // Otherwise, pick a number from 1-9 as the middle number
      this.middleNumber = Math.floor(Math.random() * 9) + 1;
    }
  }

  setOneCross(middleNumber) {
    this.setMiddleNumber(middleNumber);
    this.allNumbers = [];
    this.horizontalNumbers = new Array(5);
    this.verticalNumbers = new Array(5);
    for (let i = 1; i <= 9; i++) {
      // Create an array of numbers for other blocks, excluding the middle number
      if (i !== this.middleNumber) {
        this.allNumbers.push(i);
      }
    }
    this.shuffle();
    this.setHorizontalNumbers();
    this.setVerticalNumbers();
  }

  isSolution() {
    // Test if the cross has a solution.
    // i.e. the sum of horizontal numbers equal to the sum of vertical numbers
    return (
      this.sumArray(this.horizontalNumbers) ===
      this.sumArray(this.verticalNumbers)
    );
  }

  isUniqueSolution() {
    // If the solution has been found before.
    for (let i = 0; i < this.uniqueSolutionsList.length; i++) {
      const solution = this.uniqueSolutionsList[i];
      const horizontal = solution[0];
      const vertical = solution[1];
      if (
        this.twoArraysHaveSameElements(horizontal, this.horizontalNumbers) ||
        this.twoArraysHaveSameElements(vertical, this.horizontalNumbers)
      ) {
        return false;
      }
    }
    return true;
  }

  playOneGame(middleNumber) {
    // console.log(middleNumber);
    this.setOneCross(middleNumber);
    this.totalCounts++;
    if (this.isSolution()) {
      this.solutions++;
      // this.allSolutions.push([this.horizontalNumbers, this.verticalNumbers]);
      if (this.isUniqueSolution()) {
        this.uniqueSolutionsList.push([
          this.horizontalNumbers,
          this.verticalNumbers,
        ]);
      }
    }
  }

  twoArraysHaveSameElements(arr1, arr2) {
    // Test if two given arrays have the same elements, regardless of their orders
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr2.indexOf(arr1[i]) === -1) {
        return false;
      }
    }
    return true;
  }

  sumArray(array) {
    // Sum the numbers in an array
    let sum = 0;
    for (let i = 0; i < array.length; i++) {
      sum += array[i];
    }
    return sum;
  }

  setHorizontalNumbers() {
    this.horizontalNumbers[0] = this.allNumbers[0];
    this.horizontalNumbers[1] = this.allNumbers[1];
    this.horizontalNumbers[2] = this.middleNumber;
    this.horizontalNumbers[3] = this.allNumbers[2];
    this.horizontalNumbers[4] = this.allNumbers[3];
  }

  setVerticalNumbers() {
    this.verticalNumbers[0] = this.allNumbers[4];
    this.verticalNumbers[1] = this.allNumbers[5];
    this.verticalNumbers[2] = this.middleNumber;
    this.verticalNumbers[3] = this.allNumbers[6];
    this.verticalNumbers[4] = this.allNumbers[7];
  }

  shuffle() {
    // Shuffle an array of numbers
    // console.log(this.allNumbers);
    for (let i = this.allNumbers.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * i);
      const temp = this.allNumbers[i];
      this.allNumbers[i] = this.allNumbers[j];
      this.allNumbers[j] = temp;
    }
    // console.log(this.allNumbers);
  }

  // get allNumbers() {
  //   return this.allNumbers;
  // }

  // get verticalNumbers() {
  //   return this.verticalNumbers;
  // }

  // get horizontalNumbers() {
  //   return this.horizontalNumbers;
  // }

  // get solutions() {
  //   return this.solutions;
  // }

  // get totalCounts() {
  //   return this.totalCounts;
  // }

  // get uniqueSolutionsList() {
  //   return this.uniqueSolutionsList;
  // }
}

export default CrossGame;

// const c = new CrossGame();
// c.playOneGame();
// console.log(c.allNumbers);
// console.log(c.verticalNumbers);
// console.log(c.horizontalNumbers);
// console.log(c.uniqueSolutionsList);
